<template>
  <div class="button-standard-restrictions"
       :class="restrictionClasses"
       ref="restrictions"
       @click="onRestrictionsMenuClick">
    <icon-gear-group :disabled="!currentUser.hasPaidLicense"
                     icon-color="#8067B7"
                     width="41"
                     height="50" />

    <div ref="restrictionsMenu"
         class="dropdown-menu">
      <div class="dropdown-menu-item"
           @click="openScreenTimeManagementSettings">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.screentimeAllocation") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item"
           @click="openContentFilter">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.contentFilter") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item"
           @click="openCustomContentFilter">
        <div class="dropdown-menu-item-label">
          {{ $t("customFilters") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item"
           @click="openWebsiteSettings">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.blockAllowWebsites") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item"
           @click="openAppSettings">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.blockAllowApps") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item"
           @click="openSocialMedia">
        <div class="dropdown-menu-item-label">
          {{ $t("socialMediaProtection") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item"
           @click="openDevicesList">
        <div class="dropdown-menu-item-label">
          {{ $t("devicesStatus") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item"
           @click="openDeviceProfileManagement">
        <div class="dropdown-menu-item-label">
          {{ $t("avatarProfilePicture") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <div class="dropdown-menu-item-icon-arrow"/>
        </div>
      </div>

      <div class="dropdown-menu-item">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.maskProfanity") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <base-checkbox :value="maskProfanity" @input="changeProfanityMasking" />
        </div>
      </div>

      <div class="dropdown-menu-item">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.forceSafeSearch") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <base-checkbox :value="forceSafeSearch" @input="changeForceSafeSearchStatus" />
        </div>
      </div>

      <div class="dropdown-menu-item">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.blockAndroidDevice") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <base-checkbox :value="androidSettings" @input="changeAndroidSettings" />
        </div>
      </div>

      <div class="dropdown-menu-item">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.appRemovalProtection") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <base-checkbox :value="ziftRemovalProtection" @input="changeRemovalProtectionStatus" />
        </div>
      </div>

      <div class="dropdown-menu-item dropdown-menu-item-danger"
           @click="removeProfile">
        <div class="dropdown-menu-item-label">
          {{ $t("profileSettings.removeProfile") }}
        </div>

        <div class="dropdown-menu-item-icon">
          <icon-cross-rounded width="24" height="24" iconColor="#f35f5f" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import analytics from '@/services/analytics.js'
  import tippy from 'tippy.js'

  export default {
    props: {
      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      },

      sizeBig: {
        required: false,
        type: Boolean,
        default: false
      },
    },

    mounted() {
      this.initRestrictionsDropdown()
    },

    methods: {
      initRestrictionsDropdown() {
        tippy(this.$refs.restrictions,  {
          allowHTML: true,
          content: this.$refs.restrictionsMenu,
          trigger: 'manual',
          hideOnClick: true,
          interactive: true,
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: true,
          inertia: true,
          duration: [400, 300]
        })
      },

      onRestrictionsMenuClick() {
        analytics.sendEvent('Pk_Settings_ChProf')

        if (!this.currentUser.hasPaidLicense) {
          return
        }

        this.$refs.restrictions._tippy.show()
      },

      openDeviceProfileManagement() {
        analytics.sendEvent('Pk_EditCh_ChProf')

        this.hidePopups()

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.childProfile',
            params: {
              childId: this.childId
            }
          })

          return
        }

        this.showModal('profile', {
          childId: this.child.id
        })
      },

      openScreenTimeManagementSettings() {
        analytics.sendEvent('Pk_ScrTime')
        this.hidePopups()

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.screenTimeManagement',
            params: {
              childId: this.child.id
            }
          })

          return
        }

        this.showModal('screentime', {
          child: this.child
        })
      },

      openAppSettings() {
        analytics.sendEvent('Pk_AppsStgs')

        this.hidePopups()

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.appSettings',
            params: {
              childId: this.child.id
            }
          })

          return
        }

        this.showModal('apps', {
          childId: this.child.id,
          modeId: this.modeId
        })
      },

      openDevicesList() {
        this.hidePopups()
        this.showModal('devicesAndDeviceStatus', {
          childId: this.child.id
        })
      },

      openContentFilter() {
        analytics.sendEvent('Pk_ContFilt')

        this.hidePopups()

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.contentFilter',
            params: {
              childId: this.child.id
            }
          })

          return
        }

        this.showModal('content', {
          modeId: this.modeId,
          childId: this.child.id
        })
      },

      openCustomContentFilter() {
        this.hidePopups()

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.customFilters',
            params: {
              modeId: this.modeId,
              childId: this.child.id
            }
          })

          return
        }

        this.showModal('customFilters', {
          modeId: this.modeId,
          childId: this.child.id
        })
      },

      openWebsiteSettings() {
        analytics.sendEvent('Pk_SiteStgs')

        this.hidePopups()

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.webSettings',
            params: {
              childId: this.child.id
            }
          })

          return
        }

        this.showModal('websettings', {
          modeId: this.modeId,
          childId: this.child.id
        })
      },

      openSocialMedia() {
        this.hidePopups()
        this.showModal('socialMedia', {
          childId: this.child.id
        })
      },

      hidePopups() {
        tippy.hideAll()
      },

      changeProfanityMasking(value) {
        analytics.sendEvent('Tg_ProfanityMask', {
          value
        })

        this.updateChildSettings({
          child_id: this.child.id,
          data: {
            mask_profanity: value
          }
        })
      },

      changeForceSafeSearchStatus(value) {
        analytics.sendEvent('Tg_SafeSrch', {
          value
        })

        this.updateChildSettings({
          child_id: this.child.id,
          data: {
            force_safe_search: value
          }
        })
      },

      changeAndroidSettings(value) {
        this.updateChildSettings({
          child_id: this.child.id,
          data: {
            block_android_settings: value
          }
        })
      },

      changeRemovalProtectionStatus(value) {
        analytics.sendEvent('Tg_AppRemvProt', {
          value
        })

        this.updateChildSettings({
          child_id: this.child.id,
          data: {
            zift_removal_protection: value
          }
        })
      },

      removeProfile() {
        this.hidePopups()
        this.showModal('removeProfile', {
          childId: this.child.id
        })
      },

      ...mapActions('children', {
        updateChildSettings: 'updateChildSettings'
      })
    },

    computed: {
      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.childId)
      },

      maskProfanity() {
        return this.child ? this.child.settings.mask_profanity : false
      },

      forceSafeSearch() {
        return this.child ? this.child.settings.force_safe_search : false
      },

      androidSettings() {
        return this.child ? this.child.settings.block_android_settings : false
      },

      ziftRemovalProtection() {
        return this.child ? this.child.settings.zift_removal_protection : false
      },

      restrictionClasses() {
        return {
          'button-standard-restrictions-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-standard-restrictions {
    $button-color: map-get($colors, primary);

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    font-size: 12px;
    font-weight: bold;
    line-height: 14px;
    text-align: left;
    letter-spacing: 1.2px;
    text-transform: uppercase;

    color: map-get($colors, disabled);
    border-radius: 8px;
    transition: all .1s ease-out;
    cursor: pointer;

    &:hover {
      color: darken($button-color, 10%);
    }

    &:active {
      color: darken($button-color, 20%);
    }
  }

  .button-standard-restrictions-mobile {
    width: 80px;
    height: 60px;
  }
</style>
